import { useFeatureFlagEnabled } from "@posthog/react";

import { SILL_PRO_FLAG_KEY } from "../lib/feature-flags";

/**
 * Sill Pro is available in local development and only to production pros
 * explicitly enabled by PostHog. Existing subscription management remains
 * outside this rollout gate.
 */
export function useSillProEnabled(): boolean {
  const flag = useFeatureFlagEnabled(SILL_PRO_FLAG_KEY);
  return import.meta.env.DEV || flag === true;
}
